import { gql } from '@apollo/client';

export const GET_CDN_WIDGETS = gql`
  query getCdnWidgets($widgetId: String!) {
    getCdnWidgets(widgetId: $widgetId) {
      data
    }
  }
`;

export const GET_TABLE = gql`
  query getTable($param: tableParam) {
    getTable(param: $param) {
      data
    }
  }
`;

export const GET_CELL = gql`
  query getCell($param: tableParam) {
    getCell(param: $param) {
      data
    }
  }
`;

export const GET_AUTOMATED_COLUMNS = gql`
  query getAutomatedColumns($param: automatedColumConfigs) {
    getAutomatedColumns(param: $param)
  }
`;

export const GET_AUTOMATED_BAR_CHART = gql`
  query getAutomatedBarChart($isin: String, $type: String, $until: String, $useFactsheetUntilForCurrentYear: Boolean) {
    getAutomatedBarChart(isin: $isin, type: $type, until: $until, useFactsheetUntilForCurrentYear: $useFactsheetUntilForCurrentYear) {
      isin
      type
      from
      end
      value
    }
  }
`;

/** Custom portfolio Excel upload — same query as client FactSheet custom-portfolio widget. */
export const GET_PORTFOLIO_UPLOAD = gql`
  query getPortfolioUpload($id: String, $isins: [String!]) {
    getPortfolioUpload(id: $id, isins: $isins) {
      _id
      name
      standDerDaten
      farbthemeFund
      monatskommentar
      portfolioWidgetsData
      themeData
    }
  }
`;
